import { PropsWithChildren } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { VersionedBaseLink } from './VersionedBaseLink';

export function VersionedRouterLink({
  children,
  className,
  to,
  onClick,
  state,
  tabIndex,
  target,
  ...props
}: PropsWithChildren<LinkProps> & { 'data-qa-id'?: string }) {
  return (
    <VersionedBaseLink
      data-qa-id={props['data-qa-id']}
      className={className}
      component={Link}
      to={to}
      onClick={onClick}
      state={state}
      tabIndex={tabIndex}
      target={target}
    >
      {children}
    </VersionedBaseLink>
  );
}
